import { render } from "./Zip-codes-page.vue?vue&type=template&id=67d00674&scoped=true"
import script from "./Zip-codes-page.vue?vue&type=script&lang=js"
export * from "./Zip-codes-page.vue?vue&type=script&lang=js"

import "./Zip-codes-page.vue?vue&type=style&index=0&id=67d00674&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d00674"]])

export default __exports__